(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DAY = 86400000;
    const HOUR = 3600000;
    const MINUTE = 60000;

    /**
     * Turns "YYYY-MM-DD HH:MM" (US Eastern wall-clock time) into a UTC
     * timestamp, handling daylight saving. Returns null if invalid.
     */
    const easternToTimestamp = (value) => {
      const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec(String(value || '').trim());
      if (!match) return null;
      const [year, month, day, hour, minute] = match.slice(1).map(Number);
      const wallClockAsUtc = Date.UTC(year, month - 1, day, hour, minute);
      const check = new Date(wallClockAsUtc);
      if (
        check.getUTCFullYear() !== year ||
        check.getUTCMonth() !== month - 1 ||
        check.getUTCDate() !== day ||
        check.getUTCHours() !== hour ||
        check.getUTCMinutes() !== minute
      ) {
        return null;
      }

      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });

      // Eastern offset (in ms) at a given instant, e.g. -4h in summer, -5h in winter.
      const offsetAt = (timestamp) => {
        const parts = {};
        for (const part of formatter.formatToParts(new Date(timestamp))) {
          if (part.type !== 'literal') parts[part.type] = part.value;
        }
        const asIfUtc = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
        return asIfUtc - timestamp;
      };

      let timestamp = wallClockAsUtc - offsetAt(wallClockAsUtc);
      timestamp = wallClockAsUtc - offsetAt(timestamp);
      return timestamp;
    };

    const pad = (number) => String(number).padStart(2, '0');

    const setup = (bar) => {
      if (bar.dataset.countdownReady) return;
      bar.dataset.countdownReady = 'true';

      const inEditor = Boolean(window.Shopify && window.Shopify.designMode);
      const parsedEnd = easternToTimestamp(bar.dataset.end);
      const repeatMs = Number(bar.dataset.repeatMs) || 0;
      // In repeat mode the date is just the anchor of the cycle (0 if it is invalid).
      const end = repeatMs > 0 && parsedEnd === null ? 0 : parsedEnd;
      const units = {
        days: bar.querySelector('[data-unit="days"]'),
        hours: bar.querySelector('[data-unit="hours"]'),
        minutes: bar.querySelector('[data-unit="minutes"]'),
        seconds: bar.querySelector('[data-unit="seconds"]'),
      };
      const dayChip = bar.querySelector('[data-unit-wrap="days"]');
      let timerId = null;

      // Hide the whole bar (it stays visible inside the theme editor so it can be edited).
      const hideBar = () => {
        if (timerId) window.clearInterval(timerId);
        bar.hidden = !inEditor;
        if (inEditor) {
          units.hours.textContent = units.minutes.textContent = units.seconds.textContent = '00';
        }
      };

      if (end === null) {
        hideBar();
        return;
      }

      const tick = () => {
        let remaining;
        if (repeatMs > 0) {
          // Repeating cycle, the same for every visitor: counts down to zero, then
          // jumps back to the full length and starts again. The date above is only
          // the fixed point the cycles are measured from.
          const intoCycle = (((Date.now() - end) % repeatMs) + repeatMs) % repeatMs;
          remaining = repeatMs - intoCycle;
        } else {
          remaining = end - Date.now();
        }
        if (remaining <= 0) {
          hideBar();
          return;
        }

        const showDays = remaining > DAY;
        const days = Math.floor(remaining / DAY);
        // With days shown, hours are the remainder; otherwise they are the total (up to 24).
        const hours = showDays ? Math.floor((remaining % DAY) / HOUR) : Math.floor(remaining / HOUR);
        const minutes = Math.floor((remaining % HOUR) / MINUTE);
        const seconds = Math.floor((remaining % MINUTE) / 1000);

        dayChip.hidden = !showDays;
        units.days.textContent = pad(days);
        units.hours.textContent = pad(hours);
        units.minutes.textContent = pad(minutes);
        units.seconds.textContent = pad(seconds);
        bar.hidden = false;
      };

      tick();
      if (!bar.hidden || inEditor) timerId = window.setInterval(tick, 1000);
    };

    const init = () => document.querySelectorAll('[data-countdown-bar]').forEach(setup);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-how-to-use"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const tabs = Array.from(root.querySelectorAll('[data-tab]'));
      const cards = Array.from(root.querySelectorAll('[data-card]'));

      const activate = (index) => {
        tabs.forEach((tab, i) => {
          tab.classList.toggle('is-active', i === index);
          tab.setAttribute('aria-selected', String(i === index));
        });
        cards.forEach((card, i) => card.classList.toggle('is-active', i === index));
      };

      // Videos load and play only while their card is near the viewport (cards that
      // are hidden, e.g. inactive tabs on mobile, never load). Posters show until then.
      const lazyVideos = Array.from(root.querySelectorAll('video[data-lazy-video]'));
      const startVideo = (video) => {
        video.preload = 'metadata';
        const playing = video.play();
        if (playing && typeof playing.catch === 'function') playing.catch(() => {});
      };
      if (lazyVideos.length) {
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) startVideo(entry.target);
                else entry.target.pause();
              });
            },
            { rootMargin: '200px 0px' }
          );
          lazyVideos.forEach((video) => observer.observe(video));
        } else {
          lazyVideos.forEach(startVideo);
        }
      }

      tabs.forEach((tab, index) => tab.addEventListener('click', () => activate(index)));
      cards.forEach((card, index) => card.addEventListener('click', () => activate(index)));
    };

    const init = () => document.querySelectorAll('[data-how-to]').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-results-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const track = root.querySelector('[data-track]');
      const cards = Array.from(track.children);
      const controls = root.querySelector('[data-controls]');
      const dotsWrap = root.querySelector('[data-dots]');
      const prev = root.querySelector('[data-prev]');
      const next = root.querySelector('[data-next]');

      const dots = cards.map((card, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'results-carousel__dot';
        dot.setAttribute('aria-label', 'Go to review ' + (index + 1));
        dot.addEventListener('click', () => track.scrollTo({ left: card.offsetLeft - track.offsetLeft - 16, behavior: 'smooth' }));
        dotsWrap.append(dot);
        return dot;
      });

      const update = () => {
        const overflow = track.scrollWidth > track.clientWidth + 4;
        controls.hidden = !overflow;
        const position = track.scrollLeft + track.clientWidth / 2;
        let active = 0;
        cards.forEach((card, index) => {
          if (card.offsetLeft - track.offsetLeft <= position) active = index;
        });
        dots.forEach((dot, index) => (index === active ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current')));
      };

      const step = (direction) => {
        const width = (cards[0] ? cards[0].getBoundingClientRect().width : track.clientWidth) + 16;
        track.scrollBy({ left: direction * width, behavior: 'smooth' });
      };
      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
      window.addEventListener('resize', update);

      root.querySelectorAll('[data-more]').forEach((button) => {
        const text = button.parentElement.querySelector('[data-text]');
        if (text.scrollHeight > text.clientHeight + 1) button.hidden = false;
        button.addEventListener('click', () => {
          const open = text.classList.toggle('is-expanded');
          button.setAttribute('aria-expanded', String(open));
        });
      });

      update();
    };

    const init = () => document.querySelectorAll('[data-results-carousel]').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
